+
<template>
  <div class="page-container base-batch-list">
    <div class="page-title-container">
      <h1 class="page-title">
        Detalle del periodo: {{ $route.params.periodId }}
      </h1>
    </div>

    <div class="table-container">
      <div class="table-header">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative"
        >
          <div class="w-full w-md-auto md-flex-1">
            <div
              class="d-flex justify-content-between align-items-center justify-content-lg-start"
            >
              <div class="d-flex d-md-none">
                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold"
                  v-b-tooltip.hover
                  title="Recargar"
                  @click="loadData()"
                >
                  <i class="ri-loop-right-line"></i>
                </button>

                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold ml-0"
                  v-b-tooltip.hover
                  title="Descargar"
                  v-if="$can('manage', 'status_pago_lista_periodo_descarga_excel')"
                  @click="downloadReport()"
                >
                  <i class="ri-download-2-line"></i>
                </button>
              </div>
            </div>
          </div>

          <section
            class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0"
          >
            <div class="d-none d-md-flex">
              <button
                type="button"
                class="button-tooltip text-dark font-weight-bold"
                v-b-tooltip.hover
                title="Recargar"
                @click="loadData()"
              >
                <i class="ri-loop-right-line"></i>
              </button>

              <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold ml-0"
                  v-b-tooltip.hover
                  title="Descargar"
                  v-if="$can('manage', 'status_pago_lista_periodo_descarga_excel')"
                  @click="downloadReport()"
                >
                  <i class="ri-download-2-line"></i>
                </button>
            </div>

            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <SearchBar
                placeholder="Buscar por código de pago"
                @search="onSearch"
                @input="search = $event"
                class="flex-1"
              />
            </div>
          </section>
        </div>
      </div>

      <div class="mb-0">
        <!-- Mobile -->
        <div class="custom-table-mobile d-xl-none">
          <section class="custom-table-mobile-header">
            <div>
              <span>Código de pago</span>
            </div>
            <div>
              <span>Cantidad de ganadores</span>
            </div>
            <div>
              <span>Monto total a pagar</span>
            </div>
          </section>

          <div class="custom-table-mobile-body">
            <div class="custom-table-mobile-row" v-for="o in list" :key="o.id">
              <div class="custom-table-mobile-grid">
                <div>
                  <span>{{ o.paymentCode }}</span>
                </div>
                <div class="text-center">
                  <span>{{ o.totalCount }}</span>
                </div>

                <div>
                  <span v-decimal:pen="o.totalAmount"></span>
                </div>

                <div>
                  <button
                    type="button"
                    class="border-0 bg-transparent"
                    @click="o.showMobileData = !o.showMobileData"
                  >
                    <span v-if="!o.showMobileData">
                      <i class="ri-arrow-down-s-line"></i>
                    </span>
                    <span v-else>
                      <i class="ri-arrow-up-s-line"></i>
                    </span>
                  </button>
                </div>
              </div>

              <div class="custom-table-mobile-options mt-3">
                <router-link
                  :to="{
                    name: 'celulares-status-details-payment-code',
                    params: {
                      periodId: $route.params.periodId,
                      paymentCode: o.paymentCode,
                    },
                  }"
                  class="mr-2"
                  v-if="$can('manage', 'status_pago_lista_codigo')"
                  >Ver detalle</router-link
                >
              </div>

              <div class="pt-3" v-if="o.showMobileData">
                <ul class="list-unstyled p-0">
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Abonados:</span
                    >
                    <span>{{ o.payedCount }}</span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Total abonado:</span
                    >
                    <span v-decimal:pen="o.payedAmount"></span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Progreso:</span
                    >
                    <b-progress
                      :value="o.progress"
                      max="100"
                      show-progress
                      animated
                    ></b-progress>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->
        <table class="custom-table w-100 d-none d-xl-table">
          <thead>
            <tr>
              <th>Código de pago</th>
              <th>Cantidad de ganadores</th>
              <th>Monto total a pagar</th>
              <th>Abonados</th>
              <th>Total abonado</th>
              <th>Progreso</th>
              <th v-if="$can('manage', 'status_pago_lista_codigo')">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in list" :key="o.id">
              <td class="cell-center px-1">{{ o.paymentCode }}</td>
              <td class="cell-center px-1">{{ o.totalCount }}</td>
              <td class="text-center" v-decimal:pen="o.totalAmount"></td>
              <td class="cell-center">{{ o.payedCount }}</td>
              <td class="cell-center" v-decimal:pen="o.payedAmount"></td>
              <td class="cell-center">
                <b-progress
                  :value="o.progress"
                  max="100"
                  show-progress
                  animated
                ></b-progress>
              </td>
              <td class="cell-center d_option pr-md-2 position-relative"
                  v-if="$can('manage', 'status_pago_lista_codigo')">
                <DropdownTable>
                  <template v-slot:dropdown-content>
                    <DropdownItem
                      text="Ver detalle"
                      v-if="$can('manage', 'status_pago_lista_codigo')"
                      :to="{
                        name: 'celulares-status-details-payment-code',
                        params: {
                          periodId: $route.params.periodId,
                          paymentCode: o.paymentCode
                        }
                      }"
                    />
                  </template>
                </DropdownTable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-footer d-flex justify-content-end align-items-center">
        <pagination
          :total="total"
          :page="page"
          :page-size="pageSize"
          :pages="pages"
          :changePage="changePage"
          :changePageSize="changePageSize"
          v-if="list.length"
        />

        <div class="table-no-results" v-else>
          <p class="m-0 px-3">No se encontraron resultados.</p>
        </div>
      </div>
    </div>
    <div class="row buttons-container mb-0 mt-3">
      <div class="col text-right">
        <router-link
          :to="{ name: 'celulares-status' }"
          class="button button-light"
        >
          Volver
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import fileDownload from "js-file-download"

import { StatusService } from "../../Core/Services";

import {
  Alert,
  Constants,
  PaginationMixin,
  SearchBar,
  DropdownItem,
  DropdownTable,
  Util
} from "wize-admin";
import { BProgress } from "bootstrap-vue";

export default {
  components: {
    SearchBar,
    DropdownItem,
    DropdownTable,
    BProgress,
  },
  data() {
    return {
      list: [
        {
          id: "ACC-042-IMP-DIC24",
          quantity: 5,
          amount: 350,
          suscribers: 0,
          suscribersTotal: 0,
          progress: 50,
        },
      ],
      tooltipType: null,
      filterOptions: [
        {
          label: "Fecha de abono",
          key: "payedAt",
          type: Constants.TypeFilters.DATE,
          isRange: true,
        },
      ],
    };
  },
  mixins: [PaginationMixin],
  methods: {
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);

        const params = {
          page: this.page - 1,
          size: this.pageSize,
          sort: "period,desc",
        };

        const data = { search: this.search, ...this.filters };
        const response = await StatusService.filterPaymentCodes(
          this.$route.params.periodId,
          data,
          params
        );

        this.list = response.payload.content.map((item) => {
          return {
            ...item,
            showMobileData: false,
          };
        });

        this.total = response.payload.totalElements;
        this.pages = response.payload.totalPages;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    async downloadReport() {
      try {
        await this.$store.dispatch("app/loading", true);
        const data = { search: this.search, ...this.filters };
        const response = await StatusService.downloadStatusDetail(this.$route.params.periodId, data);
        fileDownload(response.data, Util.getFileName(response));
      } catch (error) {
        Alert.error(error);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    }
  },
  async mounted() {
    if (this.$route.params.periodId) {
      await this.loadData();
    }
  },
  async created() {},
};
</script>

<style lang="stylus" scoped></style>
